// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__3b184","list":"BalanceDue_list__1ZA2N","listRow":"BalanceDue_listRow__1c4K_","total":"BalanceDue_total__3zc3z"};